import { useContext, useMemo } from "react";
import { AddOnsByType, IAddOnAxes } from "./types";
import { AddOnsCatalogContext } from "./context";
import { indexAddOnsByType } from "./utils";

export function useAddOnsByType({
  isCloudHosted,
  isYearly,
}: IAddOnAxes): AddOnsByType {
  const addOns = useContext(AddOnsCatalogContext);

  return useMemo(
    () => indexAddOnsByType(addOns, { isCloudHosted, isYearly }),
    [addOns, isCloudHosted, isYearly],
  );
}
